import {SegmentsProps as GWCSegmentsProps, Tabs as GWCTabs, TabsProps as GWCTabsProps} from '@gwc/core'

import {useTabs} from './Tabs.hooks'

// Допустимое значение таба для GWC
export type Value = number | string

type CustomTabsProps<T extends Value, SourceProps> = Omit<SourceProps, 'children' | 'value' | 'onChange' | 'key'> & {
  value: T
  onChange: (newValue: T) => void
  items: Array<TabItem<T>>
  disabled?:
    | boolean
    | T[]
    | {
        value: T
        reason: string | boolean
      }[]
}

export type TabItem<T> = {
  value: T
  label: React.ReactNode
}

export type TabsProps<T extends Value> = CustomTabsProps<T, GWCTabsProps>

export type TabsSegmentsProps<T extends Value> = CustomTabsProps<T, GWCSegmentsProps>

function TabsInline<T extends Value>({value, onChange, items, disabled, ...props}: TabsProps<T>) {
  const tabs = useTabs(items, disabled)

  return (
    <GWCTabs onChange={onChange as (v: Value | boolean) => void} value={value as Value} {...props}>
      {tabs}
    </GWCTabs>
  )
}

function Segments<T extends Value>({value, onChange, items, disabled, ...props}: TabsSegmentsProps<T>) {
  const tabs = useTabs(items, disabled)

  return (
    <GWCTabs.Segments onChange={onChange as (v: Value | boolean) => void} value={value as Value} {...props}>
      {tabs}
    </GWCTabs.Segments>
  )
}

export const Tabs = Object.assign(TabsInline, {
  Segments,
})
